import {
  organizationsApi as sharedOrganizationsApi,
  type Organization,
  type OrganizationMember,
  type CreateOrganizationRequest,
  type UpdateOrganizationRequest,
  type OrganizationStreamer,
  type AddStreamerRequest,
} from "@/shared/api/organizations";

export const organizationsApi = {
  fetchAll: () => sharedOrganizationsApi.getAllOrganizations(),
  fetchPage: (params: {
    page: number;
    limit: number;
    search?: string;
    filterBy?: string;
    sortBy?: string;
    sortDir?: string;
  }) => sharedOrganizationsApi.getAllOrganizationsPaged(params),
  fetchMine: () => sharedOrganizationsApi.getUserOrganizations(),
  fetchById: (id: string) => sharedOrganizationsApi.getOrganization(id),
  create: (data: CreateOrganizationRequest) =>
    sharedOrganizationsApi.createOrganization(data),
  update: (id: string, data: UpdateOrganizationRequest) =>
    sharedOrganizationsApi.updateOrganization(id, data),
  updateOrganization: (id: string, data: UpdateOrganizationRequest) =>
    sharedOrganizationsApi.updateOrganization(id, data),
  members: (organizationId: string) =>
    sharedOrganizationsApi.getOrganizationMembers(organizationId),
  addMember: (
    organizationId: string,
    data: { email: string; roleId: number },
  ) => sharedOrganizationsApi.addOrganizationMember(organizationId, data),
  removeMember: (organizationId: string, userId: string) =>
    sharedOrganizationsApi.removeOrganizationMember(organizationId, userId),
  updateMemberRole: (
    organizationId: string,
    userId: string,
    roleIdOrKey: number | string,
  ) => sharedOrganizationsApi.updateMemberRole(organizationId, userId, roleIdOrKey),
  subscribe: (organizationId: string) =>
    sharedOrganizationsApi.subscribe(organizationId),
  unsubscribe: (organizationId: string) =>
    sharedOrganizationsApi.unsubscribe(organizationId),
  mySubscriptions: () => sharedOrganizationsApi.getMySubscriptions(),
  addStreamer: (organizationId: string, data: AddStreamerRequest) =>
    sharedOrganizationsApi.addStreamer(organizationId, data),
  removeStreamer: (organizationId: string, streamerId: string) =>
    sharedOrganizationsApi.removeStreamer(organizationId, streamerId),
  updateStreamerSettings: (
    organizationId: string,
    streamerId: string,
    data: { isVisible?: boolean; displayOrder?: number },
  ) => sharedOrganizationsApi.updateStreamerSettings(organizationId, streamerId, data),
  updateMemberStreamerStatus: (
    organizationId: string,
    userId: string,
    isStreamer: boolean,
  ) => sharedOrganizationsApi.updateMemberStreamerStatus(organizationId, userId, isStreamer),
  getOrgTwitchOAuthUrl: (organizationId: string, redirectUri: string) =>
    sharedOrganizationsApi.getOrganizationTwitchOAuthUrl(organizationId, redirectUri),
  connectOrgTwitchOAuth: (
    organizationId: string,
    data: { code: string; state: string; redirectUri: string },
  ) => sharedOrganizationsApi.connectOrganizationTwitchOAuth(organizationId, data),
  disconnectOrgTwitchOAuth: (organizationId: string) =>
    sharedOrganizationsApi.disconnectOrganizationTwitchOAuth(organizationId),
  getBlacklist: (organizationId: string) =>
    sharedOrganizationsApi.getOrganizationBlacklist(organizationId),
  addBlacklist: (
    organizationId: string,
    body: { username?: string; userId?: string; reason?: string },
  ) => sharedOrganizationsApi.addOrganizationBlacklist(organizationId, body),
  removeBlacklist: (organizationId: string, userId: string) =>
    sharedOrganizationsApi.removeOrganizationBlacklistEntry(organizationId, userId),
};

export type {
  Organization,
  OrganizationMember,
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
  OrganizationStreamer,
  AddStreamerRequest,
};
